import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post(
      "/driver-accounting/pending-deduction-ledgers/bulk-upload",
      payload
    );
  },
};
